/* eslint-disable jsx-a11y/anchor-is-valid */
import TextInput from "src/components/input/TextInput";
import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import React from "react";
import { LoadingButton } from "@mui/lab";
import { ESTADOS_ASPIRANTE_DESCRIPCION } from "src/utils/constantes";
import {
  esquemaDeValidacionExportarMatriz,
  valoresInicialesExportarMatriz,
} from "./utils";

export interface FormularioUsuarioExternoProps {
  handleExportar: (values: any) => void;
  cargandoPeticion: boolean;
}

const ExportarMatrizForm = ({
  handleExportar,
  cargandoPeticion,
}: FormularioUsuarioExternoProps) => {
  return (
    <Formik
      initialValues={valoresInicialesExportarMatriz}
      validationSchema={esquemaDeValidacionExportarMatriz}
      onSubmit={handleExportar}
    >
      <Form autoComplete="off">
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 0, md: 2 },
          }}
        >
          <TextInput
            label="Estado"
            name="aspiranteEstado"
            type="select"
            opciones={ESTADOS_ASPIRANTE_DESCRIPCION}
            data-testid="select-id"
          />
          <TextInput
            label="Fecha incial"
            name="fechaInicial"
            type="date"
            InputLabelProps={{ shrink: true }}
          />
          <TextInput
            label="Fecha final"
            name="fechaFinal"
            type="date"
            InputLabelProps={{ shrink: true }}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={2} marginTop={2}>
          <LoadingButton
            loading={cargandoPeticion}
            variant="contained"
            sx={{ color: "white" }}
            type="submit"
            data-testid="btn-resgistrarse"
          >
            Exportar
          </LoadingButton>
        </Box>
      </Form>
    </Formik>
  );
};

export default ExportarMatrizForm;
